// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, ".v-data-footer[data-v-9416bafc]{justify-content:center}.data-table__pre-header[data-v-9416bafc]{border-bottom:1px solid var(--pale-sky-blue)}.view-title[data-v-9416bafc]{color:#0a2463}.entity-plate[data-v-9416bafc]{color:#d81077}.card-subtitle[data-v-9416bafc]{color:#0a2463}", ""]);
// Exports
module.exports = exports;
